export const LogoMark = ({ className = "h-11 w-11" }) => (
  <span className={`block overflow-hidden rounded-xl bg-white p-0.5 shadow-sm ${className}`}>
    <img src="/img/logo-mark.png" alt="" className="h-full w-full object-contain" />
  </span>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-2.5" aria-label="Jaha Brasilpe">
    <LogoMark />
    <span className="flex flex-col leading-none">
      <span className={`font-display text-xl font-extrabold tracking-tight ${light ? "text-arena" : "text-[#1B2A5C]"}`}>Jaha Brasilpe</span>
      <span className={`mt-1 hidden text-[11px] font-semibold sm:block ${light ? "text-arena/80" : "text-tinta/70"}`}>Aquí comienza tu viaje</span>
    </span>
  </span>
);

export const LogoFull = ({ className = "" }) => (
  <img src="/img/logo.png" alt="Jaha Brasilpe — Aquí comienza tu viaje" className={`rounded-3xl bg-white ${className}`} />
);
